import { NavLink } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/events", label: "Events", testId: "nav-link-events" },
  { to: "/social", label: "Social", testId: "nav-link-social" },
  { to: "/contacts", label: "Contacts", testId: "nav-link-contacts" },
];

export const Nav = () => {
  return (
    <header className="w-full px-6 md:px-12 pt-6 md:pt-8">
      <nav
        className="flex items-start justify-between"
        aria-label="Main navigation"
        data-testid="main-nav"
      >
        <div className="flex flex-col gap-1.5">
          {LINKS.map(({ to, label, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testId}
              className={({ isActive }) =>
                `font-mono font-bold text-[12px] sm:text-[13px] tracking-[0.25em] uppercase transition-colors duration-150 hover:text-[#504439] ${
                  isActive
                    ? "text-[#1A1512] underline underline-offset-4 decoration-1"
                    : "text-[#1A1512]/80"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
        <p
          className="font-mono font-light text-[10px] md:text-xs tracking-[0.2em] md:tracking-[0.3em] uppercase text-[#1A1512] text-right"
          data-testid="nav-tagline"
        >
          Built on heat.
        </p>
      </nav>
    </header>
  );
};
